export interface ShopifyStorefrontContext {
  version: 1;
  pathname: string;
  search: string;
  parentOrigin: string;
}

declare global {
  interface Window {
    __SPLITKART_STOREFRONT__?: ShopifyStorefrontContext;
  }
}

export function getShopifyStorefrontContext(): ShopifyStorefrontContext | null {
  if (typeof window === "undefined" || window.parent === window) return null;
  const context = window.__SPLITKART_STOREFRONT__;
  if (context?.version !== 1 || !/^\/(?:shakatah-split|split\/[0-9a-f-]{16,})$/i.test(context.pathname)) return null;
  return context;
}

export function isShopifyStorefront(): boolean {
  return Boolean(getShopifyStorefrontContext()) || window.location.pathname.startsWith("/apps/splitkart/");
}

export function scrollSplitFlowToTop(): void {
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  const context = getShopifyStorefrontContext();
  if (context) window.parent.postMessage({ type: "splitkart:scroll-top" }, context.parentOrigin);
}

export function syncShopifyStorefrontLocation(location: { pathname: string; search: string }): void {
  const context = getShopifyStorefrontContext();
  if (!context || !/^\/(?:shakatah-split|split\/[0-9a-f-]{16,})$/i.test(location.pathname)) return;
  context.pathname = location.pathname;
  context.search = location.search;
  window.parent.postMessage({ type: "splitkart:navigation", pathname: location.pathname, search: location.search }, context.parentOrigin);
}
